import React from "react";
import logo from "../../Images/mindy_thumbsup_physician.png";
import logo_clipboard from "../../Images/mindy_clipboard_physician.png";
import logo_clipboard2 from "../../Images/mindy_clipboard_physician 2.png";
import mindy_sitting_patient from "../../Images/mindy_sitting_patient.png";
import logo_clipboard5 from "../../Images/mindy_clipboard_physician 5.png";
import mindy_waving_admin from "../../Images/mindy_waving_admin.png";
import "./CurvedLine.css"; // Import the CSS file
import curved_line from "../../Images/curved lines.svg";

const CurvedLine = () => {
  return (
    <div className="curved-line-container">
      <div className="large-screen-layout">
        <img
          src={curved_line}
          alt="Curved Line"
          style={{
            position: "relative",
            width: "80%",
            height: "50%",
            left: "10%",
            top: "10vh",
          }}
        />

        <img
          src={logo}
          alt="Mascot"
          style={{
            position: "absolute",
            left: "20%",
            width: "15vw",
            height: "30vh",
            // top: "10px",
            zIndex: 1,
          }}
        />
        <div
          style={{
            position: "absolute",
            width: "80vw",
            height: "35vh",
            right: "60vw",
            // top: "20vh",
            // background: "rgba(163, 226, 215, 0.25)",
            // borderRadius: " 0px 7.5vh 7.5vh 0px",
            zIndex: "0",
          }}
        >
          <h3
            style={{
              position: "absolute",
              width: "100%",
              height: "auto",
              left: "60%",
              top: "70%",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontStyle: "italic",
              fontWeight: "400",
              fontSize: "var(--font-size-5xl)",
              // lineHeight: "4vh",
              display: "flex",
              alignItems: "center",
              color: "rgba(102, 102, 102, 0.9)",
              margin: "0",
            }}
          >
            Accessible Care
          </h3>
          <p
            style={{
              position: "absolute",
              width: "40%",
              height: "auto",
              left: "60%",
              top: "90%",
              fontFamily: "Lato",
              fontStyle: "italic",
              fontWeight: "300",
              fontSize: "var(--font-size-2xl)",
              // lineHeight: "3vh",
              display: "flex",
              alignItems: "center",
              color: "rgba(102, 102, 102, 0.6)",
              margin: "0",
            }}
          >
            From the comfort of your home or anywhere you choose, providers can
            connect seamlessly with their patients. Enjoy timely, personalized
            care, ensuring your health needs are met with ease and efficiency.
          </p>
        </div>
        <img
          src={logo_clipboard2}
          alt="Mascot"
          style={{
            // position: "relative",
            // left: "2%",
            // top: "3vh",
            // width: "20%",
            // height: "30%",
            position: "absolute",
            width: "15%",
            height: "25vh",
            left: "55%",
            // top: "5%",
            zIndex: 1,
          }}
        />
        <div
          className="Analytics"
          style={{
            position: "absolute",
            // width: "80vw",
            // height: "35vh",
            // right: "60vw",
            zIndex: "0",
          }}
        >
          <div
            className="Rectangle"
            style={{
              position: "absolute",
              width: "80vw",
              height: "35vh",
              left: "50vw",
              top: "30vh",
              background: "rgba(163, 226, 215, 0.25)",
              borderRadius: "7.5vh 0px 0px 7.5vh",
              zIndex: "0",
            }}
          >
            <h3
              style={{
                position: "absolute",
                width: "100%",
                height: "auto",
                left: "5%",
                top: "20%",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontStyle: "italic",
                fontWeight: "400",
                fontSize: "var(--font-size-5xl)",
                // lineHeight: "4vh",
                display: "flex",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.9)",
                margin: "0",
              }}
            >
              Timely Insights
            </h3>
            <p
              style={{
                position: "absolute",
                width: "40%",
                height: "auto",
                left: "5%",
                top: "35%",
                fontFamily: "Lato",
                fontStyle: "italic",
                fontWeight: "300",
                fontSize: "var(--font-size-2xl)",
                // lineHeight: "3vh",
                display: "flex",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.6)",
                margin: "0",
              }}
            >
              Access MRI scan results faster than ever before. Our portal
              ensures that patients and providers receive critical diagnostic
              information promptly, supporting faster decisions and better
              outcomes.
            </p>
          </div>
        </div>
        <img
          src={logo_clipboard}
          alt="Mascot"
          style={{
            position: "absolute",
            left: "20%",
            top: "40%",
            width: "15vw",
            height: "30vh",
            zIndex: 1,
          }}
        />
        <div
          className="Scheduling"
          style={{
            position: "absolute",
            width: "80vw",
            height: "300px",
            right: "20vw",
            top: "43%",
            // background: "rgba(163, 226, 215, 0.25)",
            borderRadius: " 0px 7.5vh 7.5vh 0px",
            zIndex: "0",
          }}
        >
          <h3
            style={{
              position: "absolute",
              height: "auto",
              left: "45%",
              top: "25%",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontStyle: "italic",
              fontWeight: "400",
              fontSize: "var(--font-size-5xl)",
              // lineHeight: "4vh",
              display: "flex",
              alignItems: "center",
              color: "rgba(102, 102, 102, 0.9)",
              margin: "0",
            }}
          >
            Efficient Workflows
          </h3>
          <p
            style={{
              position: "absolute",
              width: "30%",
              height: "auto",
              left: "45%",
              top: "40%",
              fontFamily: "Lato",
              fontStyle: "italic",
              fontWeight: "300",
              fontSize: "var(--font-size-2xl)",
              // lineHeight: "3vh",
              alignItems: "center",
              margin: "0",
              color: "rgba(102, 102, 102, 0.6)",
            }}
          >
            Revolutionizing healthcare efficiency with seamless access and
            streamlined processes, empowering patients and providers to save
            time and focus on better outcomes.
          </p>
        </div>

        <div className="Reimbursements">
          <div
            className="Rectangle"
            style={{
              position: "absolute",
              width: "100%",
              height: "40vh",
              left: "20vw",
              top: "55%",
              background: "rgba(163, 226, 215, 0.25)",
              borderRadius: "7.5vh 0px 0px 7.5vh",
              zIndex: "0",
            }}
          >
            <img
              src={mindy_sitting_patient}
              alt="Mascot"
              style={{
                position: "absolute",
                left: "55%",
                width: "13vw",
                height: "30vh",
              }}
            />
            <h3
              style={{
                position: "absolute",
                width: "100%",
                height: "auto",
                left: "8%",
                top: "15%",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontStyle: "italic",
                fontWeight: "10",
                fontSize: "var(--font-size-5xl)",
                display: "flex",
                alignItems: "center",
                color: "rgba(102, 102, 102, 0.9)",
                margin: "0",
              }}
            >
              Simplified Healthcare Solutions
            </h3>
            <p
              style={{
                position: "absolute",
                width: "45%",
                height: "auto",
                left: "8%",
                top: "25%",
                fontFamily: "Lato",
                fontStyle: "italic",
                fontWeight: "300",
                fontSize: "var(--font-size-2xl)",
                display: "flex",
                alignItems: "center",
                margin: "0",
                color: "rgba(102, 102, 102, 0.6)",
              }}
            >
              Transforming diagnostics with a user-friendly portal designed to
              reduce complexity, enhance care delivery, and save valuable time
              for everyone involved.
            </p>
          </div>
        </div>

        <div className="Patient Management">
          <div
            className="Circle"
            style={{
              position: "absolute",
              width: "90vw",
              height: "90vw",
              left: "-30vw",
              top: "60%",
              background: "rgba(163, 226, 215, 0.25)",
              borderRadius: "50%",
              zIndex: "0",
            }}
          >
            <img
              src={logo_clipboard5}
              alt="Mascot"
              style={{
                position: "absolute",
                left: "50%",
                top: "5%",
                width: "18vw",
                height: "30vh",
                zIndex: "5",
              }}
            />
            <h3
              style={{
                position: "absolute",
                width: "100%",
                height: "auto",
                left: "45%",
                top: "25%",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontStyle: "italic",
                fontWeight: "400",
                fontSize: "var(--font-size-5xl)",
                display: "flex",
                textAlign: "center",
                alignItems: "center",
                margin: "0",
                color: "rgba(102, 102, 102, 0.9)",
              }}
            >
              Access Management
            </h3>
            <p
              style={{
                position: "absolute",
                width: "30%",
                height: "auto",
                left: "45%",
                top: "30%",
                fontFamily: "Lato",
                fontStyle: "italic",
                fontWeight: "10",
                fontSize: "var(--font-size-2xl)",
                display: "flex",
                alignItems: "center",
                margin: "0",
                color: "rgba(102, 102, 102, 0.6)",
              }}
            >
              Our role-based access system ensures that only authorized
              individuals can view and manage MRI scans, enabling secure
              collaboration and maintaining privacy.
            </p>
          </div>
        </div>

        <div className="Secure Compliance">
          <img
            src={mindy_waving_admin}
            alt="Mascot"
            style={{
              position: "absolute",
              left: "70%",
              top: "68%",
              width: "15vw",
              height: "30vh",
              zIndex: 1,
            }}
          />
          <h3
            style={{
              position: "absolute",
              width: "100%",
              height: "auto",
              left: "60%",
              top: "66%",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontStyle: "italic",
              fontWeight: "180",
              margin: "0",
              fontSize: "var(--font-size-5xl)",
              color: "rgba(102, 102, 102, 0.9)",
            }}
          >
            Secure Compliance
          </h3>
          <p
            style={{
              position: "absolute",
              width: "30%",
              height: "auto",
              left: "60%",
              top: "67%",
              fontFamily: "Lato",
              fontStyle: "italic",
              fontSize: "var(--font-size-2xl)",
              color: "rgba(102, 102, 102, 0.6)",
              margin: "0",
            }}
          >
            Your health information is safe with us. Built with advanced
            encryption and strict data privacy protocols, the neuro42 Health
            Portal ensures your medical records are protected at all times.
          </p>
        </div>
      </div>

      <div className="small-screen-layout">
        <div className="card">
          <img src={logo} alt="Mascot" className="card-image" />
          <h3 className="card-title">Accessible Care</h3>
          <p className="card-text">
            From the comfort of your home or anywhere you choose, physicians can
            connect seamlessly with their patients. Enjoy timely, personalized
            care, ensuring your health needs are met with ease and efficiency.
          </p>
        </div>

        <div className="card">
          <img src={logo_clipboard2} alt="Mascot" className="card-image" />
          <h3 className="card-title">Analytics</h3>
          <p className="card-text">
            Leverage powerful analytics to track patient progress and outcomes.
            Make informed decisions based on data-driven insights, ensuring
            better patient care and operational efficiency.
          </p>
        </div>

        <div className="card">
          <img src={logo_clipboard} alt="Mascot" className="card-image" />
          <h3 className="card-title">Scheduling</h3>
          <p className="card-text">
            Manage appointments with ease. Our intuitive scheduling tools ensure
            that your time is well-organized, reducing no-shows and maximizing
            efficiency.
          </p>
        </div>

        <div className="card">
          <img
            src={mindy_sitting_patient}
            alt="Mascot"
            className="card-image"
          />
          <h3 className="card-title">Reimbursements</h3>
          <p className="card-text">
            Streamline the reimbursement process, ensuring that you are
            compensated promptly and accurately for the care you provide. Focus
            on patient care, not paperwork.
          </p>
        </div>

        <div className="card">
          <img src={logo_clipboard5} alt="Mascot" className="card-image" />
          <h3 className="card-title">Patient Management</h3>
          <p className="card-text">
            From the comfort of your home or anywhere you choose, physicians can
            connect seamlessly with their patients. Enjoy timely, personalized
            care, ensuring your health needs are met with ease and efficiency.
          </p>
        </div>

        <div className="card">
          <img src={mindy_waving_admin} alt="Mascot" className="card-image" />
          <h3 className="card-title">Secure Compliance</h3>
          <p className="card-text">
            From the comfort of your home or anywhere you choose, physicians can
            connect seamlessly with their patients. Enjoy timely, personalized
            care, ensuring your health needs are met with ease and efficiency.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CurvedLine;
